module.exports = __webpack_public_path__ + "static/media/drag.b680e4ed.gif";